import { ReactNode } from 'react';

interface CatalogFormSectionProps {
  id: string;
  title: string;
  description: string;
  children: ReactNode;
}

export function CatalogFormSection({ id, title, description, children }: CatalogFormSectionProps) {
  return (
    <section className="catalog-form-section" id={id} aria-labelledby={`${id}-title`}>
      <header><h2 id={`${id}-title`}>{title}</h2><p>{description}</p></header>
      <div className="catalog-form-section__fields">{children}</div>
    </section>
  );
}
